import { capitalize } from '@crazyegginc/hatch';
import { FEATURES } from '/src/features/_global/constants';

export function externalizeLinks(parentElement) {
  const links = parentElement.querySelectorAll('a');
  links.forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });
}

export function getCategoryName(category) {
  switch (category.toUpperCase()) {
    case FEATURES.ADDONS:
      return 'Add-Ons';
    case FEATURES.CTAS:
      return 'CTAs';
    case FEATURES.AB_TESTING:
      return 'A/B Testing';
    case FEATURES.WHATS_NEW:
      return "What's new";
    case FEATURES.GOALS:
      return 'Conversions';
    case FEATURES.SNAPSHOTS:
      return 'Heatmaps';
    default:
      return category
        .split('_')
        .map((x) => capitalize(x))
        .join(' ');
  }
}
